import { useState } from 'react'
import { StyleUtil } from 'utils/StyleUtil'
import { ToastUtil } from 'utils/ToastUtil'
import closeSvg from '../images/close2.svg'
import Spinner from './Spinner'
import React from 'react'
import { Quiz } from 'apis/entities/quiz.entity'
import { ValidationUtil } from 'utils/ValidationUtil'
import { useQuizApi } from 'providers/QuizApiProvider'

interface Props {
  quiz: Quiz
  onClose: (success: boolean) => void
  'data-testid'?: string
}

export default function WidgetAddReviewers({
  quiz,
  onClose,
  'data-testid': dataTestId,
}: Props): JSX.Element {
  const { addQuizReviewers } = useQuizApi()
  const refInputReviewers = React.createRef<HTMLTextAreaElement>()
  const [isLoading, setIsLoading] = useState(false)

  const onClickConfirm = async () => {
    try {
      const tmp = refInputReviewers.current?.value ?? ''
      const emails = tmp.split(',').map((email) => email.trim())
      if (tmp.length === 0 || emails.length === 0) {
        ToastUtil.warning('Please enter at least one email')
        return
      }
      // validate all emails
      for (const email of emails) {
        if (!ValidationUtil.isEmail(email)) {
          ToastUtil.warning(`Invalid email: ${email}`)
          return
        }
      }
      setIsLoading(true)
      await addQuizReviewers(quiz.id, emails)
      ToastUtil.success('Email(s) sent successfully')
      onClose(true)
    } catch (error) {
      console.log(error)
      ToastUtil.error('Failed to send email(s)')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div
      className="absolute z-[999] flex h-full w-full flex-col items-center justify-center bg-[#D5D5DBAA]"
      data-testid={dataTestId}
    >
      <div className="flex h-auto flex-col gap-[12px] bg-white px-[24px] py-[16px] shadow-xl">
        <img
          src={closeSvg}
          className="cursor-pointer self-end"
          alt="close"
          onClick={() => onClose(false)}
        />
        {quiz.reviewers.length > 0 && (
          <p className="quiz-email-message px-[12px]">
            We have populated this list with the emails you sent to previously.
            Please make sure you have taken in all feedback before sending for
            review again.
          </p>
        )}
        <div className="flex flex-col">
          <textarea
            cols={66}
            rows={6}
            placeholder="Type email address here, seperate email(s) by comma"
            className="quiz-email-input"
            ref={refInputReviewers}
            defaultValue={quiz.reviewers
              .filter((reviewer) => reviewer.version === quiz.version)
              .map((reviewer) => reviewer.email)
              .join(',')}
          />
        </div>
        {isLoading && <Spinner />}
        {!isLoading && (
          <div className="flex items-center justify-center">
            <button
              type="button"
              className={StyleUtil.buttonPrimaryUnsw}
              onClick={() => onClickConfirm()}
            >
              Confirm
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
